import React, { Component } from 'react'
import SRCards from '../../components/SRCards'
import TicketApi from '../../services/ticket.service'
import {
    Button, Container, Paper, TableContainer, TextField, Table,
    TableHead, TableRow, TableCell, TableBody, TableFooter,
    Dialog, DialogTitle, DialogContent, DialogActions, Snackbar, Typography
} from '@material-ui/core'
import { Alert } from '@material-ui/lab';

type IProps = {
    location: any
}
type IState = {
    tickets: any;
    dialog: any;
    confirmMsg: any;
    pageResponse: any;
    snackBar: any;
    searchValue:any;
    ticketToBeDeleted: any;
}
const apiservices = new TicketApi();

class TicketList extends Component<IProps, IState> {
    constructor(props: any) {
        super(props);
        this.state = {
            tickets: [],
            dialog: false,
            confirmMsg: null,
            pageResponse: null,
            snackBar: '',
            searchValue:null,
            ticketToBeDeleted: null
        };
    }

    async onSearch(e: any) {
        if (e.key === 'Enter') {
            const response = await apiservices.getTickets(
                e.target.value
            );
            this.setState({
                tickets: response,
                searchValue: e.target.value
            })
        }
    }

    async confirm(ticketId: any, ticketNumber: any) {
        let res = `This operation will delete ticket - ${ticketNumber} 
                    along with its related invoices, estimates, checklists, 
                    assignments, forms, notes and timecards.`
        this.setState({
            dialog: true,
            confirmMsg: res,
            ticketToBeDeleted: ticketId
        })
        return
    }

    async cancel() {
        this.setState({
            dialog: false,
            snackBar: 'info',
            pageResponse: `Deletion Cancelled.`
        })
    }

    async delete() {
        const { ticketToBeDeleted, searchValue } = this.state;
        let response = await apiservices.deleteTicket(ticketToBeDeleted);
        if (response && response.id) {
            const updated = await apiservices.getTickets(
                searchValue
            );
            this.setState({
                dialog: false,
                snackBar: 'success',
                pageResponse: "Deleted Successfully.",
                tickets: updated
            })
        }
        else {
            let msg;
            if(response && response.message && response.description) {
                msg = `Delete Failed: ${response.message} - ${response.description}`
            } else {
                msg = `Delete Failed.`
            }
            this.setState({
                dialog: false,
                snackBar: 'error',
                pageResponse: msg
            })
        }
    }

    render() {
        return (
            <div>
                <SRCards />
                <Container>
                    <Typography
                        style={{
                            padding: 16
                        }}
                    >
                        {localStorage.getItem('selectedCompanyDisplay')}
                    </Typography>
                    <TextField
                        style={{ padding: 16 }}
                        variant="outlined"
                        onKeyDown={(e) => this.onSearch(e)}
                        placeholder='Search Ticket..' />
                    <TableContainer
                        component={Paper}
                        style={{
                            padding: 10, margin: 16
                        }}
                    >
                        <Table
                            style={{
                                minWidth: 700
                            }}
                            aria-label="customized table">
                            <TableHead>
                                <TableRow>
                                    {/* <TableCell>Select</TableCell> */}
                                    <TableCell>Action</TableCell>
                                    <TableCell>Ticket Number</TableCell>
                                    <TableCell>Customer Name</TableCell>
                                    <TableCell>Address</TableCell>
                                    <TableCell>Job Type</TableCell>
                                    <TableCell>Description</TableCell>
                                    <TableCell>Start Time</TableCell>
                                    <TableCell>End Time</TableCell>
                                    <TableCell>Job Status</TableCell>
                                </TableRow>
                            </TableHead>
                            {this.state.tickets.length > 0 ?
                                this.state.tickets.map((ticket: any) => {
                                    return (
                                        <TableBody>
                                            <TableRow>
                                                <TableCell>
                                                    <Button
                                                        style={{ margin: 10 }}
                                                        variant='outlined'
                                                        onClick={this.confirm.bind(
                                                            this, 
                                                            ticket.id, 
                                                            ticket.ticketNumber
                                                            )
                                                        }
                                                    >
                                                        Delete
                                                    </Button>
                                                </TableCell>
                                                {/* <TableCell>
                                                <Checkbox
                                                    key={set.id}
                                                    defaultChecked={false}
                                                    checked={
                                                        this.isItemSelected(set.id)
                                                    }
                                                    onChange={() => {
                                                        this.handleSelect(set.id)
                                                        if (!this.state.id.includes(set)) {
                                                            this.state.id.push(set)
                                                        }
                                                        else {
                                                            const i = this.state.id.indexOf(set);
                                                            this.state.id.splice(i, 1)
                                                        }
                                                        this.setState({
                                                            id: this.state.id,
                                                            customerType: 0
                                                        })
                                                    }
                                                    } />
                                                </TableCell> */}
                                                <TableCell>
                                                    {ticket.ticketNumber}
                                                </TableCell>
                                                <TableCell>
                                                    {ticket.serviceAddress && ticket.serviceAddress.displayName?
                                                    ticket.serviceAddress.displayName:''}
                                                </TableCell>
                                                <TableCell>
                                                    {ticket.serviceAddress && ticket.serviceAddress.addressLine1?
                                                    ticket.serviceAddress.addressLine1:''},
                                                    {ticket.serviceAddress && ticket.serviceAddress.city?
                                                    ticket.serviceAddress.city:''},
                                                    {ticket.serviceAddress && ticket.serviceAddress.state?
                                                    ticket.serviceAddress.state:''},
                                                    {ticket.serviceAddress && ticket.serviceAddress.zipcode?
                                                    ticket.serviceAddress.zipcode:''}
                                                </TableCell>
                                                <TableCell>
                                                    {ticket.jobType}
                                                </TableCell>
                                                <TableCell>
                                                    {ticket.jobDescription}
                                                </TableCell>
                                                <TableCell>
                                                    {ticket.startTime}
                                                </TableCell>
                                                <TableCell>
                                                    {ticket.endTime}
                                                </TableCell>
                                                <TableCell>
                                                    {ticket.jobStatus}
                                                </TableCell>
                                            </TableRow>
                                        </TableBody>
                                    )
                                }) : null}
                            <TableFooter>
                                <TableRow>

                                </TableRow>
                            </TableFooter>
                        </Table>
                    </TableContainer>
                    <Dialog
                        open={this.state.dialog}
                        onClose={() => {
                            this.setState({
                                dialog: false
                            })
                        }}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description">
                        <DialogTitle id="alert-dialog-title">
                            {'Confirmation!'}
                        </DialogTitle>
                        <DialogContent>
                            {this.state.confirmMsg}
                        </DialogContent>
                        <DialogActions>
                            <Button
                                onClick={
                                    () => {
                                        this.setState({
                                            confirmMsg:'Processing...'
                                        })
                                        this.delete()
                                    }
                                }
                            >
                                Confirm
                                </Button>
                            <Button
                                onClick={
                                    () => this.cancel()
                                }
                                autoFocus
                            >
                                Cancel
                                </Button>
                        </DialogActions>
                    </Dialog>
                    <Snackbar
                        open={this.state.snackBar === '' ? false : true}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right',
                        }}
                        autoHideDuration={6000}
                        onClose={() => {
                            this.setState({
                                snackBar: ''
                            })
                        }}
                    >
                        <Alert
                            severity={this.state.snackBar}
                            onClose={() => {
                                this.setState({
                                    snackBar: ''
                                })
                            }
                            }>
                            {this.state.pageResponse}
                        </Alert>
                    </Snackbar>
                </Container>
            </div>
        )
    }
}

export default TicketList;